module.exports = __webpack_public_path__ + "static/media/reformer3.9537ab9b.jpg";